import { Button, CardActions, CardContent, Checkbox, FormControlLabel, TextField } from "@mui/material";
import React, { useMemo, useState } from "react";
import { DialogHeader } from "../../generics/dialog-header";
import { EventSeriesInstance } from "../utils";

type EditEventSeriesDialogProps = {
  existing?: {
    id: number;
    name: string;
    isActive: boolean;
  };
  ok: (result: any) => void;
  cancel: (result: any) => void;
};

export const EditEventSeriesDialog: React.FC<EditEventSeriesDialogProps> = ({ existing = null, ok, cancel }) => {
  const [name, setName] = useState(existing?.name || "");
  const [isActive, setIsActive] = useState(existing?.isActive || false);

  const isNew = useMemo(() => !existing, [existing]);
  const isValid = useMemo(() => name.length > 0, [name]);
  const handleSave = () => {
    if (!isValid) return;

    if (isNew) {
      // Add new event series
      EventSeriesInstance.create({ name }).then(ok);
      return;
    }

    // Update existing event series
    EventSeriesInstance.update((existing as any).id, { name, isActive }).then(ok);
  };
  return (
    <>
      <DialogHeader title={`${isNew ? "Add" : "Edit"}  Event Series`} />
      <CardContent>
        <TextField fullWidth label="Name" value={name} onChange={(e) => setName(e.target.value)} required />
        {existing && (
          <FormControlLabel
            sx={{ mx: 2, mt: 1, float: "right" }}
            control={<Checkbox checked={isActive ?? false} onChange={(e) => setIsActive(e.target.checked)} />}
            label="Active"
          />
        )}
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end", px: 2 }}>
        <Button onClick={cancel} variant="text">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={!isValid}>
          Save
        </Button>
      </CardActions>
    </>
  );
};
